<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_2"></a>Tor Books by Nancy Kress</p>
<p class="center-para">_______________________</p>
<p class="para"> </p>
<p class="center-para"><em>Beaker’s Dozen</em></p>
<p class="center-para"><em>Beggars and Choosers</em></p>
<p class="center-para"><em>Beggars Ride</em></p>
<p class="center-para"><em>Crossfire</em></p>
<p class="center-para"><em>Crucible</em></p>
<p class="center-para"><em>Maximum Light</em></p>
<p class="center-para"><em>Oaths and Miracles</em></p>
<p class="center-para"><em>Probability Moon</em></p>
<p class="center-para"><em>Probability Space</em></p>
<p class="center-para"><em>Probability Sun</em></p>
<p class="center-para"><em>Steal Across the Sky</em></p>
<p class="center-para"><em>Stinger</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?5175c7b2